import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTonyukanriNo"
    label="投入管理No"
    size="small"
    inputProps={{ maxLength: 11 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;